import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { FaTelegram, FaWhatsapp } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [showNotification, setShowNotification] = useState(false);

  const handleTelegramClick = () => {
    window.open('https://t.me/ktayfun', '_blank');
  };

  const handleWhatsappClick = () => {
    window.open('https://wa.me/79131544311', '_blank');
  };

  const handleEmailClick = async () => {
    const email = 'proteko.rus@mail.ru';
    try {
      await navigator.clipboard.writeText(email);
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 3000);
    } catch (err) {
      console.error('Failed to copy email: ', err);
    }
  };

  const TelegramIcon = FaTelegram as React.ComponentType<{ className?: string }>;
  const WhatsAppIcon = FaWhatsapp as React.ComponentType<{ className?: string }>;

  return (
    <>
      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {/* Логотип и описание для десктопа */}
            <div className="hidden md:block space-y-4">
              <div className="flex items-center space-x-2">
                <span className="text-2xl font-bold">
                  <span className="text-accent-purple">ПРО</span>
                  <span className="text-accent-purple">Т</span>
                  <span className="text-accent-green">ЭКО</span>
                </span>
                <svg className="w-10 h-10" viewBox="0 0 581.102 581.102" xmlns="http://www.w3.org/2000/svg">
                  <g id="layer_1" data-name="Layer">
                    <g clipPath="url(#clip_1)">
                      <path transform="matrix(1,0,0,-1,480.7455,568.12869)" d="M0 0H-380.5C-406.622 0-430.296 10.62-447.436 27.731-464.608 44.889-475.241 68.587-475.241 94.694V455.342C-475.241 481.496-464.626 505.147-447.486 522.305-430.315 539.463-406.641 550.129-380.5 550.129H0C26.122 550.129 49.815 539.463 66.986 522.305 84.144 505.147 94.718 481.496 94.718 455.342V94.694C94.718 68.587 84.098 44.889 66.931 27.731 49.796 10.62 26.122 0 0 0M-380.5 22.213H0C20.052 22.213 38.184 30.328 51.317 43.452 64.413 56.529 72.514 74.661 72.514 94.694V455.342C72.514 475.422 64.398 493.554 51.28 506.678 38.184 519.801 20.052 527.917 0 527.917H-380.5C-400.552 527.917-418.684 519.801-431.784 506.678-444.899 493.554-453.033 475.422-453.033 455.342V94.694C-453.033 74.661-444.917 56.529-431.817 43.452-418.703 30.328-400.552 22.213-380.5 22.213" fill="#2fb474" fillRule="evenodd"/>
                      <path transform="matrix(1,0,0,-1,304.6695,111.39548)" d="M0 0C0 26.479-21.485 47.996-48.001 47.996-74.504 47.996-96.007 26.479-96.007 0-96.007-26.526-74.504-48.044-48.001-48.044-21.485-48.044 0-26.526 0 0" fill="#000205" fillRule="evenodd"/>
                      <path transform="matrix(1,0,0,-1,204.2984,245.9252)" d="M0 0C0-108.654-73.655-186.282-73.655-186.282-73.655-186.282-147.31-108.654-147.31 0-147.31 108.607-73.655 196.716-73.655 196.716-73.655 196.716 0 108.607 0 0" fill="#2fb474" fillRule="evenodd"/>
                      <path transform="matrix(1,0,0,-1,379.9708,331.8092)" d="M0 0C-82.545-66.361-160.401-36.542-160.401-36.542-160.401-36.542-181.849 48.229-99.304 114.543-16.755 180.903 130.607 197.366 130.607 197.366 130.607 197.366 82.55 66.314 0 0" fill="#2fb474" fillRule="evenodd"/>
                      <path transform="matrix(1,0,0,-1,351.6043,526.0681)" d="M0 0C-110.443-20.682-207.322 57.828-207.322 57.828-207.322 57.828-139.918 125.534-29.47 146.216 80.973 166.899 187.089 122.101 187.089 122.101 187.089 122.101 110.448 20.682 0 0" fill="#2fb474" fillRule="evenodd"/>
                    </g>
                  </g>
                </svg>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">
                Компания специализируется на экологически чистых продуктах для жизни. 
                Мы предлагаем натуральные удобрения, корма и добавки для животных, 
                а также качественные БАДы для поддержания вашего здоровья.
              </p>
            </div>

            {/* Большие иконки соцсетей для мобильных */}
            <div className="md:hidden space-y-6">
              <div className="text-center">
                <h3 className="text-xl font-semibold text-white mb-2">Мы в соцсетях</h3>
                <p className="text-gray-300 text-sm">Свяжитесь с нами удобным способом</p>
              </div>
              <div className="flex justify-center space-x-6">
                <button
                  onClick={handleTelegramClick}
                  className="group relative p-5 bg-gradient-to-br from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 rounded-full transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 shadow-xl hover:shadow-2xl"
                >
                  <div className="absolute inset-0 bg-white/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <TelegramIcon className="w-10 h-10 text-white relative z-10" />
                  <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-blue-600 text-white text-xs px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300">
                    Telegram
                  </div>
                </button>
                <button
                  onClick={handleWhatsappClick}
                  className="group relative p-5 bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 rounded-full transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 shadow-xl hover:shadow-2xl"
                >
                  <div className="absolute inset-0 bg-white/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <WhatsAppIcon className="w-10 h-10 text-white relative z-10" />
                  <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-green-600 text-white text-xs px-2 py-1 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300">
                    WhatsApp
                  </div>
                </button>
              </div>
            </div>

            {/* Меню и контакты для мобильных */}
            <div className="md:hidden space-y-6">
              <div className="grid grid-cols-2 gap-6">
                {/* Навигация */}
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold">Навигация</h3>
                  <nav className="flex flex-col space-y-2">
                    <Link
                      to="/shop"
                      className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm"
                    >
                      Магазин
                    </Link>
                    <Link
                      to="/products"
                      className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm"
                    >
                      Продукция
                    </Link>
                    <Link
                      to="/about"
                      className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm"
                    >
                      О нас
                    </Link>
                    <Link
                      to="/delivery"
                      className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm"
                    >
                      Доставка/Оплата
                    </Link>
                  </nav>
                </div>

                {/* Контакты */}
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold">Контакты</h3>
                  <div className="space-y-3">
                    {/* Выбор города */}
                    <div className="flex items-center space-x-3 text-gray-300 text-sm">
                      <MapPin className="w-4 h-4 text-primary-400" />
                      <span>Омск</span>
                    </div>

                    <a 
                      href="tel:+79131544311"
                      className="flex items-center space-x-3 text-gray-300 text-sm hover:text-primary-400 transition-colors duration-200"
                    >
                      <Phone className="w-4 h-4 text-primary-400" />
                      <span>+7 (913) 154-43-11</span>
                    </a>
                    <button
                      onClick={handleEmailClick}
                      className="flex items-center space-x-3 text-gray-300 text-sm hover:text-primary-400 transition-colors duration-200"
                    >
                      <Mail className="w-4 h-4 text-primary-400" />
                      <span>proteko.rus@mail.ru</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Меню для десктопа */}
            <div className="hidden md:block space-y-4">
              <h3 className="text-lg font-semibold">Навигация</h3>
              <nav className="flex flex-col space-y-2">
                <Link
                  to="/shop"
                  className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm"
                >
                  Магазин
                </Link>
                <Link
                  to="/products"
                  className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm"
                >
                  Продукция
                </Link>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm"
                >
                  О нас
                </Link>
                <Link
                  to="/delivery"
                  className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm"
                >
                  Доставка/Оплата
                </Link>
              </nav>
            </div>

            {/* Контакты для десктопа */}
            <div className="hidden md:block space-y-4">
              <h3 className="text-lg font-semibold">Контакты</h3>
              <div className="space-y-3">
                {/* Выбор города */}
                <div className="flex items-center space-x-3 text-gray-300 text-sm">
                  <MapPin className="w-4 h-4 text-primary-400" />
                  <span>Омск</span>
                </div>

                <a 
                  href="tel:+79131544311"
                  className="flex items-center space-x-3 text-gray-300 text-sm hover:text-primary-400 transition-colors duration-200"
                >
                  <Phone className="w-4 h-4 text-primary-400" />
                  <span>+7 (913) 154-43-11</span>
                </a>
                <button
                  onClick={handleEmailClick}
                  className="flex items-center space-x-3 text-gray-300 text-sm hover:text-primary-400 transition-colors duration-200"
                >
                  <Mail className="w-4 h-4 text-primary-400" />
                  <span>proteko.rus@mail.ru</span>
                </button>
              </div>
            </div>
          </div>

          {/* Нижняя строка */}
          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <p className="text-gray-400 text-sm mb-2">
              © {currentYear} ПРОТЭКО.РУС. Все права защищены.
            </p>
            <Link
              to="/privacy"
              className="text-gray-500 hover:text-gray-300 transition-colors duration-200 text-sm"
            >
              Информация о конфиденциальности
            </Link>
          </div>
        </div>
      </footer>

      {/* Notification Toast */}
      {showNotification && (
        <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50">
          <div className="bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg flex items-center space-x-2 animate-bounce">
            <Mail className="w-4 h-4" />
            <span>Email скопирован в буфер обмена!</span>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
